import { render, staticRenderFns } from "./DonutChartHC.vue?vue&type=template&id=22659705"
import script from "./DonutChartHC.vue?vue&type=script&lang=js"
export * from "./DonutChartHC.vue?vue&type=script&lang=js"
import style0 from "./DonutChartHC.vue?vue&type=style&index=0&id=22659705&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports